import React from "react";
import projectData from "../Data/projectsData";

function Projects() {
  return (
    <section className="section-5">
      <div className="row">
        <div className="head-content">
          <h2>Recent Projects</h2>
          <p>
            Detail-oriented use of modern technologies, libraries and frameworks to define project
            expectations and demands for clients
          </p>
        </div>
        <div className="project--cards" data-aos="zoom-out">
          <>
            {projectData.map((card) => {
              return (
                <div key={card.id} className="project-card-1">
                  <div className="p-browser">
                    <div className="p-circle"></div>
                    <div className="p-circle"></div>
                    <div className="p-circle"></div>
                  </div>
                  <a href={card.url} target="_blank" rel="noreferrer">
                    <img src={card.image} alt="" className="p-image" />
                  </a>
                </div>
              );
            })}
          </>
        </div>
      </div>
    </section>
  );
}

export default Projects;
